(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

// function updateFacetPanelStyles() {
//   document.querySelectorAll(".facets__panel").forEach((details) => {
//     const label = details.querySelector(".facets__summary .facets__label");
//     const caret = details.querySelector(".facets__summary .icon-caret");
//     const svgPath = caret?.querySelector("svg path");

//     if (details.hasAttribute("open")) {
//       if (label) label.style.color = "#B46100";
//       if (caret) caret.style.background = "#B46100";
//       if (svgPath) svgPath.style.fill = "#fff";
//     } else {
//       if (label) label.style.color = "#4a4a4a";
//       if (caret) caret.style.background = "rgb(74 74 74 / 30%)";
//       if (svgPath) svgPath.style.fill = "currentColor";
//     }
//   });
// }

// // 1️⃣ Panel toggle (open/close)
// document.addEventListener(
//   "toggle",
//   (e) => {
//     if (!e.target.classList.contains("facets__panel")) return;
//     updateFacetPanelStyles();
//   },
//   true
// );

// // 2️⃣ Checkbox change
// document.addEventListener("change", (e) => {
//   if (!e.target.closest(".facets__inputs-list-item .checkbox__input")) return;
//   setTimeout(updateFacetPanelStyles, 1000); // wait for Shopify AJAX filter reload
// });

// // 3️⃣ Price input typing + focus out
// function handlePriceFacetUpdate(e) {
//   if (
//     !e.target.closest(
//       ".facets .facets__inputs-wrapper.price-facet__inputs-wrapper .price-facet__input"
//     )
//   )
//     return;
//   setTimeout(updateFacetPanelStyles, 300);
// }
// document.addEventListener("input", handlePriceFacetUpdate);
// document.addEventListener("focusout", handlePriceFacetUpdate);

// // 4️⃣ Click inside facets (fallback / safety)
// document.addEventListener("click", (e) => {
//   if (!e.target.closest(".facets")) return;
//   setTimeout(updateFacetPanelStyles, 300);
// });

// // 5️⃣ Delegated click for facet-remove-component (pill or Clear all)
// document.addEventListener("click", (e) => {
//   const removePill = e.target.closest("facet-remove-component");
//   const clearAllBtn = e.target.closest(".facets__clear-all-link");

//   if (removePill?.classList.contains("facets-remove__pill") || clearAllBtn || removePill?.querySelector(".facets__clear-all-link")) {
//     setTimeout(updateFacetPanelStyles, 300);
//   }
// });

// // 6️⃣ Run on page load
// window.addEventListener("DOMContentLoaded", () => {
//   updateFacetPanelStyles();
// });





  } catch(e) { console.error(e); }
})();
})();
